import _ from 'lodash'
import reportApi from '@/api/report'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  loading: false,
  filters: {
    dateRange: {
      start: null,
      end: null,
    },
  },
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    state.loading = true
    reportApi.getDigitalCurrencyOrders({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
  },
  download({ commit }) {
    reportApi.getDigitalCurrencyOrdersFile({ ...state.filters })
      .then(response => commit('DOWNLOAD_REPORT', response))
  },
  sync({ commit }) {
    store.dispatch('message/load')

    return reportApi.syncOrders({ ...state.filters })
      .then(() => {
        store.dispatch('message/loadFinish')
        store.dispatch('message/success', 'Синхронизация заказов выполнена')
        store.dispatch('digitalCurrency/fetchList')
      })
      .catch(error => {
        store.dispatch('message/loadFinish')
        const data = error.response && error.response.data

        const validation = data && data.validationErrors
        const text = validation
          ? Object.values(validation).reduce((all, msgs) => all.concat(msgs), []).join('; ')
          : (data && data.message) || 'Не удалось синхронизировать заказы'
        store.dispatch('message/error', text)
      })
  },

}

const mutations = {
  SET_LIST(state, items) {
    state.list = items
    state.loading = false
  },
  DOWNLOAD_REPORT(state, response) {
    const url = window.URL.createObjectURL(response.data)
    const link = document.createElement('a')
    const fileName = 'Отчет.xlsx'
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    window.URL.revokeObjectURL(url)
  },
  CLEAR_ERRORS(state) {
    state.errors = []
  },
  ...generateFormHandlerMutations(state),
}

const modules = {}

const watchers = [
  [state => state.digitalCurrency.filters, _.debounce(async () => await store.dispatch('digitalCurrency/fetchList'), 250), {
    immediate: false,
    deep: true,
  }],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
